/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DocumentToSubmitType } from './DocumentToSubmitType';
import {
    DocumentToSubmitTypeFromJSON,
    DocumentToSubmitTypeFromJSONTyped,
    DocumentToSubmitTypeToJSON,
    DocumentToSubmitTypeToJSONTyped,
} from './DocumentToSubmitType';

/**
 * 
 * @export
 * @interface AddDocumentToPalAuthSubmissionRequest
 */
export interface AddDocumentToPalAuthSubmissionRequest {
    /**
     * 
     */
    type: DocumentToSubmitType;
    /**
     * 
     */
    s3_key: string;
    /**
     * 
     */
    custom_name?: string;
}



/**
 * Check if a given object implements the AddDocumentToPalAuthSubmissionRequest interface.
 */
export function instanceOfAddDocumentToPalAuthSubmissionRequest(value: object): value is AddDocumentToPalAuthSubmissionRequest {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('s3_key' in value) || value['s3_key'] === undefined) return false;
    return true;
}

export function AddDocumentToPalAuthSubmissionRequestFromJSON(json: any): AddDocumentToPalAuthSubmissionRequest {
    return AddDocumentToPalAuthSubmissionRequestFromJSONTyped(json, false);
}

export function AddDocumentToPalAuthSubmissionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddDocumentToPalAuthSubmissionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'type': DocumentToSubmitTypeFromJSON(json['type']),
        's3_key': json['s3_key'],
        'custom_name': json['custom_name'] == null ? undefined : json['custom_name'],
    };
}

export function AddDocumentToPalAuthSubmissionRequestToJSON(json: any): AddDocumentToPalAuthSubmissionRequest {
    return AddDocumentToPalAuthSubmissionRequestToJSONTyped(json, false);
}

export function AddDocumentToPalAuthSubmissionRequestToJSONTyped(value?: AddDocumentToPalAuthSubmissionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': DocumentToSubmitTypeToJSON(value['type']),
        's3_key': value['s3_key'],
        'custom_name': value['custom_name'],
    };
}

